module.exports = "/images/vendor/flag-icon-css/flags/4x3/hn.svg?9b9bee13c67ab85cd468d1c5fe38ad3e";